var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "ml-1" }, [
    _c(
      "a",
      {
        attrs: { href: "#" },
        on: {
          click: function($event) {
            return _vm.$emit("apply-filter", _vm.column, _vm.toggleSort)
          }
        }
      },
      [
        !_vm.selected
          ? _c("font-awesome-icon", {
              attrs: {
                icon: ["fas", "exchange-alt"],
                color: "lightgray",
                rotation: "90"
              }
            })
          : _c("font-awesome-icon", {
              attrs: { icon: ["fas", _vm.iconDisplayed], color: "black" }
            })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }